<template>
    <div class="container my-5">
        <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg bg-white">
            <div class="col-lg-7 p-3 p-lg-5 pt-lg-3">
                <h1 class="display-4 fw-bold lh-1">{{ title }}</h1>
                <p class="lead">{{ description }}.</p>
                <div class="d-grid gap-2 d-md-flex justify-content-md-start mb-4 mb-lg-3">
                    <router-link :to="path" type="button" class="btn btn-primary btn-lg px-4 me-md-2 fw-bold">{{ title }}</router-link>
                </div>
            </div>
            <div class="col-lg-4 offset-lg-1 p-0 overflow-hidden shadow-lg">
                <img class="rounded-lg-3" :src="image" alt="Servicios" width="520">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            title: String,
            description: String,
            path: String,
            image: String
        }
    }
</script>

<style scoped>
    @media (min-width: 992px) {
        .rounded-lg-3 { border-radius: .3rem; }
    }
</style>